import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  & > div:nth-of-type(even) {
    background: ${colors.grayExtraLight};
  }
  height: 100%;
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
`
